export default __webpack_public_path__ + "static/media/cms-customer-add.8a6969d6.svg";